import _ from 'lodash';
import { toLower, replace } from 'lodash';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PT from 'prop-types';
import {
  Icon,
  Table,
  Popup,
} from 'semantic-ui-react';
import FiltersHeader from '../../components/FiltersHeader';
import PrimaryDropdown from '../../components/FilterComponents/PrimaryDropdown';
import TableControls from '../../components/TableControls';
import Link from '../../../lib/components/link';
import { DropdownOptionsType } from '../../../lib/proptypes/semantic';
import {
  selectWeeksWithPreSeasonForDropdown,
} from '../../../store/reducers/season';
import { selectControlsState } from '../../../store/reducers/tableControls';
import { positionToTitle } from '../../../lib/lookups';
import { goToView } from '../../routes.global';
import {
  selectTop200,
  selectTop200State,
  loadTop200,
  TOP200_VIEW,
} from './module/top200';
import { selectFormulas } from '../../../store/reducers/formula';
import { FormulaType } from '../../../lib/proptypes/formula';
import classes from './top200.css';
import { PLAYER_VIEW } from '../Player/module/player';
import rookieIcon from '../../../assets/images/icon-rookie.png';
import upsideIcon from '../../../assets/images/upside.png';
import downsideIcon from '../../../assets/images/downside.png';
import analysisIcon from '../../../assets/images/icon-analysis.png';
import analysisIconUpdated from '../../../assets/images/icon-analysis-updated.png';
import {
  selectToolDescriptionsState,
} from '../../../store/reducers/toolDescriptions';
import { ToolDescription } from '../../components/ToolDescriptions/ToolDescriptions';
import { gciPageView } from '../../../lib/analytics';

const pageTitle = 'Fantasy Football Cheat Sheets: Top 200';

const mapStateToProps = state => {
  const { hasLoaded, year, week, formulaId } = selectTop200State(state);
  const {
    toolDescriptions,
    toolsLoaded,
  } = selectToolDescriptionsState(state);
  const loggedIn = state.auth.loggedIn;
  return {
    hasLoaded,
    selectedYear: year,
    selectedWeek: week,
    selectedProfile: formulaId,
    collapsed: selectControlsState(state).collapsed,
    toolDescriptions,
    toolsLoaded,
    loggedIn,
    ...hasLoaded && {
      top200: selectTop200(state),
      weeks: selectWeeksWithPreSeasonForDropdown(state, year, 'projections'),
      profiles: selectFormulas(state),
    },
  };
};
const actions = {
  goToView,
};
export class Top200 extends PureComponent {
  static propTypes = {
    weeks: DropdownOptionsType,
    selectedProfile: PT.number,
    selectedWeek: PT.number,
    selectedYear: PT.number,
    top200: PT.objectOf(PT.arrayOf(PT.shape({
      player_id: PT.number.isRequired,
      fname: PT.string.isRequired,
      lname: PT.string.isRequired,
      team: PT.string.isRequired,
      position: PT.string.isRequired,
      // fpts: PT.number.isRequired,
      bye: PT.number.isRequired,
      rank: PT.number.isRequired,
    }))),
    hasLoaded: PT.bool.isRequired,
    collapsed: PT.bool.isRequired,
    goToView: PT.func.isRequired,
    profiles: PT.arrayOf(FormulaType),
    toolsLoaded: PT.bool.isRequired,
    loggedIn: PT.bool.isRequired,
    gciPageView: PT.func.isRequired,
  }

  static defaultProps = {
    weeks: [
      { key: 0, value: 0, text: 'Pre Season' },
    ],
    top200: null,
    selectedWeek: null,
    selectedYear: null,
    selectedProfile: null,
    profiles: [],
    loggedIn: false,
  }

  state = {
    prevLogin: false,
    didFirst: false,
  }

  /* Tier Names */
  // numeralNames = ['', 'ONE', 'TWO', 'THREE', 'FOUR', 'FIVE', 'SIX', 'SEVEN', 'EIGHT']

  componentDidMount() {
    document.title = pageTitle + ' - TheHuddle';
    gciPageView(pageTitle);
    this.setState({ didFirst: true });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.didFirst && this.state.prevLogin !== prevProps.loggedIn) {
      const { selectedYear, selectedProfile, selectedWeek } = this.props;
      this.setState({ prevLogin: prevProps.loggedIn });
      if (this.props.loggedIn & this.props.top200['1'].length < 3 ) {
        window.location.reload();
      }
    }
  }

  handleChangeYear = (event, { value }) => {
    const { selectedYear, selectedWeek, selectedProfile } = this.props;
    if (selectedYear !== value) {
      this.props.goToView(
        TOP200_VIEW,
        {
          params: { year: value, week: selectedWeek, formulaId: selectedProfile },
          updateQuery: false,
        },
      );
    }
  }

  handleChangeTimeFrame = (event, { value }) => {
    if (this.props.selectedWeek !== value) {
      this.props.goToView(TOP200_VIEW, { query: { week: value } });
    }
  }

  handleChangeProfile = (event, { value }) => {
    if (this.props.selectedProfile !== value) {
      this.props.goToView(TOP200_VIEW, { query: { formulaId: value } });
    }
  }

  renderPlayerRow = ({ player_id: id, rank, position, fname, lname, team, bye, writeup, injured, rookie, upside, downside }) => {
    const name = `${fname} ${lname}`;
    const goPlayer = id => ({ type: PLAYER_VIEW, payload: { id, name: toLower(replace(fname + lname, /\./g, '')) } });

    return (
      <Table.Row key={id}>
        <Table.Cell textAlign="center">{`${rank}.`}</Table.Cell>
        <Table.Cell textAlign="center">{position}</Table.Cell>
        <Table.Cell textAlign="center" className={classes.playerCell}>
            <Link
              to={goPlayer(id)}
              className={classes.playerName}
            >
              {name}
              {rookie==="Y" ? <img src={rookieIcon} alt="" className={classes.rookieIcon} /> : ""}
              {upside==="Y" ? <img src={upsideIcon} alt="" className={classes.upsideIcon} /> : ""}
              {downside==="Y" ? <img src={downsideIcon} alt="" className={classes.downsideIcon} /> : ""}
            </Link>

          {writeup
            ? <Popup
              trigger={<span className={classes.floatRight}><a role="button">{injured ? <Icon className={classes.injuryStatusIcon} name="plus" size="large" /> : <img src={analysisIcon} alt="" className={classes.analysisIcon} />}</a></span>}
              header={`${name} Analysis`}
              content={writeup}
              position="top center"
              wide
              on="hover"
              className={classes.analysisPopup}
              />
            : ""
          }
        </Table.Cell>
        <Table.Cell textAlign="center">{team}</Table.Cell>
        <Table.Cell textAlign="center">{bye}</Table.Cell>
      </Table.Row>
    );
  }

  renderTier = (tier, players) => {
    const playersByTier = players.filter(player => player.tier === tier);

    return (
      <fØ>
        {playersByTier.map(player => this.renderPlayerRow(player))}
      </fØ>
    );
  }

  renderPositionTable = players => {
    const maxTier = players[players.length - 1].tier;
    const tiers = [];
    for (let i = 0; i < maxTier; i++) tiers.push(i + 1);

    const wrapperClass = classNames(
      classes.positionTable,
      { [classes.collapsed]: this.props.collapsed },
    );

    let hasCombined = this.props.profiles.find(profile => profile.id === this.props.selectedProfile);
    const combinedWRTE = hasCombined ? hasCombined.combine : undefined;

    const playerPosition = players[0].position === 'WR' && combinedWRTE ? 'wr,te' : players[0].position;

    return (
      <div className={wrapperClass} key={players[0].player_id}>
        <Table unstackable celled striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign="center" className={classes.rankHeader}>Rank</Table.HeaderCell>
              <Table.HeaderCell textAlign="center" className={classes.ffptsHeader}>Pos</Table.HeaderCell>
              <Table.HeaderCell textAlign="center"className={classes.playerHeader}>Player</Table.HeaderCell>
              <Table.HeaderCell textAlign="center">Team</Table.HeaderCell>
              <Table.HeaderCell textAlign="center" className={classes.byeHeader}>Bye</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {tiers.map(tier => this.renderTier(tier, players))}
          </Table.Body>
        </Table>
      </div>
    );
  }

  render = () => {
    const {
      selectedYear,
      selectedWeek,
      selectedProfile,
      weeks,
      top200,
      hasLoaded,
      toolDescriptions,
      toolsLoaded,
    } = this.props;

    let printLink = '';

    // Always returns false if there's no data for index 0
    // const hasData = !!(top200 && Object.values(top200)[0].length);

    // Updated it to loop through the top200 results until it finds at least one position w/data
    const hasData = !!(top200 && typeof window !== 'undefined' && _.find(Object.values(top200), position => position.length));

    if (hasData) {
      printLink = location.href.split('/');
      printLink.length = 3; // just need http://xxx.com
      printLink = printLink.join('/') + '/top-200-standard/' + selectedYear + '/' + selectedWeek + '/' + selectedProfile + '/false/print';
    }

    let clientWidth = null;

    if (typeof window !== 'undefined') {
      clientWidth = document.documentElement.clientWidth || document.body.clientWidth;
    }

    return (
      <div className={classes.wrapper}>
        <FiltersHeader
          title={pageTitle}
          seasonType={selectedWeek === 0 ? 'preseasons' : 'seasons'}
          description={toolsLoaded && toolDescriptions.tool_descriptions.top200.visible == 1 && (
            <ToolDescription
              descr={toolDescriptions.tool_descriptions.top200.text}
            />)}
          statType="projections"
          selectedYear={selectedYear}
          selectedProfile={selectedProfile}
          offFilters={false}
          onChangeProfile={this.handleChangeProfile}
          onChangeYear={this.handleChangeYear}
          stacked
          printLink={clientWidth && clientWidth > 350 ? printLink : null}
        >
          <PrimaryDropdown
            label="Timeframe:"
            activeItem={selectedWeek}
            onChange={this.handleChangeTimeFrame}
            choices={weeks}
            className={classes.singleDropdown}
          />
        </FiltersHeader>

        <TableControls />

        <div className={classes.tablesWrapper}>
          {hasLoaded && hasData && Object.values(top200).map(position =>
            position.length ? this.renderPositionTable(position) : null,
          )}
        </div>

        {(hasLoaded && !hasData) && <h3>No data available for this period.</h3>}

      </div>
    );
  }
  }
export default connect(mapStateToProps, actions)(Top200);



// WEBPACK FOOTER //
// ./src/app/views/Top200/Top200.js